import { darkenHex, hexToRgb } from "@ai-guidance/shared";

/**
 * Cele patru lumini din care e făcut orbul. Prototipul le avea scrise de mână,
 * ca patru palete fixe; aici se DERIVĂ din culoarea proprietarului
 * (`branding.primaryColor`), altfel orbul ar rămâne violet pe un site verde.
 *
 * Numele vin din prototip (`docs/prototypes/presence.html`) și se păstrează, ca
 * să poți compara cadru cu cadru când reglezi.
 */
export interface PresencePalette {
  /** Miezul aprins - centrul orbului și scânteile. */
  core: string;
  /** Marginea adâncă, spre care cade gradientul corpului. */
  deep: string;
  /** Lumina care iese din formă: halo, umbre colorate, firul de ghidare. */
  glow: string;
  /** Waveform-ul - vizibil pe fundal deschis, deci nu la fel de aprins ca `core`. */
  wave: string;
}

/** Violetul de brand, când contul n-are personalizare (vezi `widget.ts` → `--aig-primary`). */
export const DEFAULT_PRIMARY = "#8b5cf6";

/** Nuanță mai deschisă. Perechea lui `darkenHex`, care există deja în `shared`. */
export function lightenHex(hex: string, amount: number): string {
  const [r, g, b] = hexToRgb(hex);
  const up = (c: number): number => Math.round(c + (255 - c) * amount);
  return `#${[up(r), up(g), up(b)].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
}

/**
 * Factorii sunt calibrați pe violetul de brand ca să reproducă paleta din
 * prototip: pentru `#8b5cf6` ies nuanțe practic identice cu `core:#c9b8ff`,
 * `deep:#4c1d95`, `wave:#a78bfa` scrise acolo de mână.
 */
export function paletteFrom(primary: string = DEFAULT_PRIMARY): PresencePalette {
  return {
    core: lightenHex(primary, 0.58),
    deep: darkenHex(primary, 0.46),
    glow: primary,
    wave: lightenHex(primary, 0.3),
  };
}

/** `#rrggbb` + alfa → `rgba(...)`, forma pe care o cere canvasul. */
export function rgba(hex: string, alpha: number): string {
  const [r, g, b] = hexToRgb(hex);
  return `rgba(${r},${g},${b},${alpha})`;
}
